/** Textes « suppression » — le français fait foi. */
export const suppression = {
  types: {
    vehicule: 'Véhicule', client: 'Client', location: 'Location', contrat: 'Contrat', facture: 'Facture',
    caution: 'Caution', entretien: 'Entretien', amende: 'Amende', sinistre: 'Sinistre', assurance: 'Assurance',
  },
  aideVehicule: 'Une voiture qui a servi ne se supprime pas : archivez-la, elle sort des listes sans rien perdre.',
  aideLocation: "Une location qui a reçu de l'argent s'annule, elle ne s'efface pas : la caisse doit garder sa trace.",
  aideFacture: 'Les factures sont numérotées en continu : un trou dans la série se verra.',
  contravention: 'contravention',
  police: 'police',
  supprimee: (type: string, l: string) => `${type} « ${l} » supprimé(e). Le journal en garde la copie complète.`,
  echec: "La suppression n'a pas abouti.",
  titre: 'Supprimer une fiche',
  sousTitre: 'Définitif. La fiche entière est recopiée dans le journal avant de disparaître.',
  avertTitre: "Avant d'effacer, demandez-vous si l'annulation ou l'archivage ne suffit pas",
  avertTexte: 'Une location annulée reste dans les dettes avec son argent ; une voiture archivée sort des listes sans perdre son historique. La suppression, elle, ne se rattrape pas : seule la copie au journal permettra de dire ce que la fiche contenait.',
  fiches: (type: string, n: number) => `${type} — ${n} fiche(s)`,
  chercher: 'Chercher…',
  rien: 'Rien à afficher',
  supprimer: 'Supprimer',
  definitivement: 'Supprimer définitivement',
  modaleTexte: 'Cette fiche va disparaître du logiciel. Le journal gardera son contenu complet, votre nom et le motif que vous écrivez ici.',
  motif: 'Motif (obligatoire)',
  motifAide: 'Pourquoi cette fiche ne doit plus exister.',
  motifExemple: 'Saisie en double, créée par erreur lors de la formation…',
  annuler: 'Annuler',
};
